import { Box, Slider, Typography } from '@mui/material'
import { getSizeTierLabel, getSizeTierForCount } from './pricingData'

interface EmployeeSliderProps {
  value: number
  onChange: (value: number) => void
}

const marks = [
  { value: 1, label: '1' },
  { value: 25, label: '25' },
  { value: 75, label: '75' },
  { value: 225, label: '225' },
  { value: 300, label: '300+' },
]

function EmployeeSlider({ value, onChange }: EmployeeSliderProps) {
  const sizeTier = getSizeTierForCount(value)
  const tierLabel = getSizeTierLabel(sizeTier)

  return (
    <Box sx={{ maxWidth: 600, width: '100%', mx: 'auto', px: { xs: 1, sm: 3 }, py: { xs: 1, sm: 2 } }}>
      <Typography variant="h6" sx={{ textAlign: 'center', mb: 1, fontSize: { xs: '1rem', sm: '1.25rem' } }}>
        How many employees do you have?
      </Typography>
      <Typography variant="body1" sx={{ textAlign: 'center', mb: { xs: 2, sm: 3 }, color: 'text.secondary' }}>
        <strong>{value >= 300 ? '300+' : value}</strong> employees &middot; {tierLabel}
      </Typography>
      <Slider
        value={value}
        onChange={(_, newValue) => onChange(newValue as number)}
        min={1}
        max={300}
        marks={marks}
        valueLabelDisplay="auto"
        valueLabelFormat={(v) => (v >= 300 ? '300+' : String(v))}
        sx={{
          color: '#087575',
          '& .MuiSlider-markLabel': {
            fontSize: '0.75rem',
          },
          '& .MuiSlider-thumb': {
            '&:hover, &.Mui-focusVisible': {
              boxShadow: '0 0 0 8px rgba(8, 117, 117, 0.16)',
            },
          },
        }}
      />
    </Box>
  )
}

export default EmployeeSlider
